// Module
var code = `<div class="forgot_control {{^(.visible)}}hidden {{/}}">
    <div class="closeBtn_forgot_screen">
        <investingButton investingButtonStyle="close_button" on-btnClick="@this.closeScreenEventClick()" />
    </div>
    <div class="name_forgot_screen">{{header}}</div>
    <div class="edit_forgot_section">
        <div class="{{currentStep === TerceraRecoverScreen.CredentialStep ? '' : 'hidden'}}">
            <investingTextBox name="loginTextBox" styleClassed="investing_input_container_login" text="{{valueLogin}}" placeholder="{{textLoginLabel}}"  />
            <investingTextBox styleClassed="investing_input_container_login" text="{{valueEmail}}" placeholder="{{textEmailLabel}}" />
        </div>

        <div class="{{currentStep === TerceraRecoverScreen.VerificationCodeStep ? '' : 'hidden'}}">
            <investingTextBox name="keyTextBox" styleClassed="investing_input_container_login" text="{{valueKey}}" placeholder="{{textKeyLabel}}" />
            <!-- <div class="recover-password-screen-hint">{{hintText}}</div> -->
        </div>

        {{#if currentStep === TerceraRecoverScreen.NewPasswordStep}}
        <div>
            <investingPasswordTextBox passwordHided="{{newPassHided}}" elementStyle="investing_input_container_login" text="{{valueNewPassword}}" placeholder="{{textNewPasswordLabel}}" showPasswordPreview="{{allowPasswordPreview}}"/>
            <investingPasswordTextBox passwordHided="{{confirmPassHided}}" elementStyle="investing_input_container_login" text="{{valueConfirm}}" placeholder="{{textConfirmLabel}}" showPasswordPreview="{{allowPasswordPreview}}"/>
        </div>
        {{/if}}
    </div>

    <div class="recover-screen-footer-buttons">
        {{#if @this.backBtnVisible()}}
        <investingButton investingButtonStyle="blue_button_investing" width="200" height="32" text="{{backText}}" on-btnClick="@this.backClick()" />
        {{/if}}
        {{#if @this.nextBtnVisible()}}
        <investingButton investingButtonStyle="blue_button_investing" width="317" height="32" text="{{nextText}}" on-btnClick="@this.nextClick()" enabled="{{nextBtnEnabled}}" />
        {{/if}}
        {{#if @this.finishBtnVisible()}}
        <investingButton investingButtonStyle="blue_button_investing" width="200" height="32" text="{{recoverText}}" on-btnClick="@this.nextClick()" enabled="{{recoverBtnEnabled}}" />
        {{/if}}
    </div>
</div>`;
// Exports
export default code;